export default {
  default: () => import("/app/layouts/default.vue").then(m => m.default || m),
  empty: () => import("/app/layouts/empty.vue").then(m => m.default || m)
}